import React, { useMemo } from 'react';
import ThumbOverlayBackgroundDS from '@wix/da-ds/pkg/thumbs/legos/ThumbOverlayBackground';
import HoverOnly from '@wix/da-ds/pkg/thumbs/OverlayHelpers/HoverOnly';
import { useDeviationBlockType } from '../../hooks/useDeviationBlockType';
var ThumbOverlayBackground = function (_a) {
    var deviation = _a.deviation, className = _a.className, showDefaultHover = _a.showDefaultHover;
    var blockType = useDeviationBlockType(deviation);
    var backgroundType = useMemo(function () {
        // mature and such gets solid
        if (blockType === 'matureFilter') {
            return 'solid';
        }
        // stuff that gets blurred images gets a gradient
        if (blockType) {
            return 'gradient';
        }
    }, [blockType]);
    if (backgroundType) {
        return (React.createElement(ThumbOverlayBackgroundDS, { type: backgroundType, className: className }));
    }
    if (showDefaultHover) {
        return (React.createElement(HoverOnly, null,
            React.createElement(ThumbOverlayBackgroundDS, { type: "gradient", className: className })));
    }
    return null;
};
ThumbOverlayBackground.displayName = 'ThumbOverlayBackground';
export default ThumbOverlayBackground;
//# sourceMappingURL=ThumbOverlayBackground.js.map